import { handleLogout } from '../helpers';

const INTERVAL = process.env.REACT_APP_IBL_TRACKING_INTERVAL ?? 30_000;
const INACTIVITY_THRESHOLD =
  process.env.REACT_APP_IBL_INACTIVITY_THRESHOLD ?? 60_000;
const MIN_TRACKING_DURATION =
  process.env.REACT_APP_IBL_TRACKING_DURATION ?? 5_000;
const api = new window.IblJsClient.default(
  {
    IBL_API_PROXY_URL: process.env.REACT_APP_IBL_WEB_URL,
    IBL_LMS_URL: process.env.REACT_APP_IBL_LMS_URL,
    IBL_DM_URL: process.env.REACT_APP_IBL_DM_URL,
    trackingConfig: {
      INTERVAL,
      INACTIVITY_THRESHOLD,
      MIN_TRACKING_DURATION,
    },
    FEATURES: {
      EDX_USE_JWT: process.env.REACT_APP_IBL_AUTH_EDX_USE_JWT === 'true',
    },
  },
  { errors: { 401: handleLogout } }
);

api.initiateAxdClientsWithAxdWebUrl(process.env.REACT_APP_IBL_AXD_URL);
api.isDirectAxdAuth = process.env.REACT_APP_IBL_IS_DIRECT_AXD_AUTH === 'true';
api.spaLoginPath = process.env.REACT_APP_IBL_SPA_LOGIN_PATH;

export { api };
